import React, { Component } from 'react';
import API from '@/api/api';
import zhCN from 'antd/es/locale/zh_CN';
import { Table, Button, Modal, message, ConfigProvider } from 'antd';
import TextArea from 'antd/lib/input/TextArea';

// /insuranceBroker/invitationList

class InvitationList extends Component {

  constructor(props) {
    super(props);
  }

  state = {

    remarkModal: {
      show: false,
      remark: '',
      recordId: '',
    },

    columns: [//直播列表表头
      {
        title: '用户ID',
        dataIndex: 'userId',
      },
      {
        title: '用户昵称',
        dataIndex: 'nickName',
      },
      {
        title: '注册时间',
        dataIndex: 'registerTimeFormat',
      },
      {
        title: '提交时间',
        dataIndex: 'submitTimeFormat',
      },
      {
        title: '姓名',
        dataIndex: 'userName',
      },
      {
        title: '电话',
        dataIndex: 'userPhone',
      },
      {
        title: '身份证号',
        dataIndex: 'idNum',
      },
      {
        title: '从业年限',
        dataIndex: 'workYear',
      },
      {
        title: '就职保司',
        dataIndex: 'companyName',
      },
      {
        title: '生日',
        dataIndex: 'birthday',
      },
      {
        title: '资格审核',
        dataIndex: 'statusType',
        render: (statusType, record) => (
          <div className="operateBtnBlock">
            {
              statusType == 0 ? '待提交' :
                statusType == 2 ? '符合-待邀请' :
                  statusType == 3 ? '符合-待参加' :
                    statusType == 4 ? '符合-待邀请&待参加' :
                      statusType == 5 ? '符合-已激活' :
                        statusType == 6 ? '不符合' :
                          statusType == 1 ?
                            record.recordId ?
                              <>
                                <Button type="primary" onClick={this.thdMatch.bind(this, 1, record.recordId)}>符合</Button>
                                <Button style={{ marginLeft: '20px' }} type="danger" onClick={this.thdMatch.bind(this, 0, record.recordId)}>不符合</Button>
                              </> : '' : ''
            }
          </div>
        )
      },
      {
        title: '线下沙龙',
        dataIndex: 'joinSalonStatus',
        render: (joinSalonStatus) => {
          return joinSalonStatus == 1 ? '已参加' : '未参加'
        },
      },
      {
        title: '备注',
        dataIndex: 'remark',
        render: (remark, record) => (
          <>
            <span>{remark}</span>
            {record.recordId && <Button type="primary" onClick={this.openModel.bind(this, record)}>{remark ? '修改' : '添加'}备注</Button>}
          </>
        ),
      }
    ],

    searchCondition: {//直播列表搜索条件
      pageSize: 5,
      pageNo: 1,
    },

    pagination: {
      defaultPageSize: 5,
      hideOnSinglePage: true,
      showTotal: total => `总${total}条`,
      onChange: this.onPaginationChange.bind(this),
    },

  }
  componentDidMount() {
    let { userId } = this.props.location.state;
    let { searchCondition } = this.state;
    searchCondition.shareUserId = userId;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  onPaginationChange(page, pageSize) {
    let { searchCondition } = this.state;
    searchCondition.pageNo = page;
    this.setState({ searchCondition }, () => {
      this.getListData()
    })
  }

  async thdMatch(isMatch, recordId) {
    console.log('isMatch, recordId', isMatch, recordId)
    let result = await API.thdCheckList({ isMatch, recordId })
    if (result.status == 1) {
      this.getListData();
    }
  }

  openModel(record) {
    let { remarkModal } = this.state;
    remarkModal.remark = record.remark;
    remarkModal.recordId = record.recordId;
    remarkModal.show = true
    this.setState({ remarkModal })
  }

  hideModel() {
    let { remarkModal } = this.state;
    remarkModal.remark = '';
    remarkModal.recordId = '';
    remarkModal.show = false
    this.setState({ remarkModal })
  }

  remarkChange(e) {
    const { remarkModal } = this.state;
    remarkModal.remark = e.target.value;
    this.setState({ remarkModal })
  }

  async thdRemark() {
    let result = await API.thdRemark(this.state.remarkModal);
    if (result.status == 1) {
      message.success('操作成功')
      this.getListData();
      return;
    }
    message.error(result.msg)
  }

  async getListData() {
    let { searchCondition, pagination } = this.state;
    let result = await API.thdCheckList(searchCondition)
    if (result.status == 1) {
      let data = result.data;
      pagination.total = Number(data.totalNum);
      // pagination.current = searchCondition.pageIndex;
      this.setState({
        datas: data.datas,
        pagination
      })
    }
  }


  render() {
    const {
      pagination,
      columns,
      datas,
      remarkModal
    } = this.state;
    return (
      <ConfigProvider locale={zhCN}>
        <Table
          columns={columns}
          dataSource={datas}
          pagination={pagination}
          onChange={this.handleTableChange}
          rowKey='userId'
        />
        <Modal
          destroyOnClose={true}
          title='备注'
          onCancel={this.hideModel.bind(this)}
          onOk={this.thdRemark.bind(this)}
          visible={remarkModal.show}
          width={500}
        >
          <div className="modalPane">
            <TextArea value={remarkModal.remark} placeholder="请输入备注" onChange={this.remarkChange.bind(this)}></TextArea>
          </div>
        </Modal>
      </ConfigProvider>
    )
  }
}

export default InvitationList;